import { render, staticRenderFns } from "./StatisticsProgramPartner.vue?vue&type=template&id=9f6ad650&"
import script from "./StatisticsProgramPartner.vue?vue&type=script&lang=js&"
export * from "./StatisticsProgramPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports